import { render, staticRenderFns } from "./p12.vue?vue&type=template&id=7c3d5f4a&scoped=true&"
import script from "./p12.vue?vue&type=script&lang=js&"
export * from "./p12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3d5f4a",
  null
  
)

export default component.exports